import EnterpriseApiService from "src/api/EnterpriseApiService"
import { queryOptions } from "./v4QueryOptions/queryOptions"

export const getGrowerIdsOptions = (showActive: boolean = false) => {
    return queryOptions({
        queryKey: ["growers", {onlyActive: showActive}] as const,
        queryFn: async (q) => {
            return await EnterpriseApiService.getGrowerIDs(showActive);
        }
    });
}